import { memo, useEffect, useState } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';

import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface IProps {
  value?: number | string | undefined;
  selectedValue?: number | string | undefined;
  title?: string;
  subTitle?: string;
  imgSrc?: string;
  textColor?: string;
  bgColor?: string;
  className?: string;
  rs?: string;
  onClick?: () => void;
}

const SubGnbItem = ({
  value,
  selectedValue = '',
  title,
  subTitle,
  imgSrc,
  textColor = '#000',
  bgColor = '#FFE6DE',
  className,
  rs = '150',
  onClick,
}: IProps) => {
  const [isActive, setIsActive] = useState(
    String(value) === String(selectedValue)
  );

  const cName = classNameBind([
    'sub-gnb-item item',
    isActive ? 'active' : '',
    className || '',
  ]);

  useEffect(() => {
    setIsActive(String(value) === String(selectedValue));
  }, [value, selectedValue]);

  return (
    <S.SubGnbItem className={cName} $textcolor={textColor} $bgcolor={bgColor}>
      <Button className="area-click" onClick={onClick}>
        <div className="text-area">
          <Text
            className="title"
            block
            weight={600}
            size={13}
            lineHeight="130%"
          >
            {title}
          </Text>
          {subTitle && (
            <Text className="sub-title" block size={12} lineHeight="130%">
              {subTitle}
            </Text>
          )}
        </div>
        {imgSrc && (
          <Img
            src={getResizeImageUrl(imgSrc, rs)}
            width={42}
            height={42}
            priority
            alt={title}
          />
        )}
      </Button>
    </S.SubGnbItem>
  );
};

export default memo(SubGnbItem);
